import React, {createContext, ReactNode, useContext, useState} from 'react';
import Cookies from 'js-cookie';

interface AuthContextType {
    isLoggedIn: boolean;
    logIn: () => void;
    logOut: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
    children: ReactNode;
}


export const AuthProvider: React.FC<AuthProviderProps> = ({ children } ) => {

    const isLoggedInUser: string|undefined = Cookies.get('username');
    const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false)

    const logIn = () => {
        setIsLoggedIn(true);
    };

    const logOut = () => {
        sessionStorage.clear(); //clearing the storage
        setIsLoggedIn(false);
    };

    return (
        <AuthContext.Provider value={{ isLoggedIn, logIn, logOut }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
